<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
        lg12
      >
        <material-card
          color="general"
          title="Shodan Data"
          text="List of Prospective Shodan(s)"
        >
          <v-layout
            row
            wrap>
            <v-flex
              xs6
              sm6
              md3
            >
              <v-text-field
                v-model="search"
                prepend-icon="search"
                label="Search"
                placeholder="Search by Company/Customer/Name/Desc"
                clearable
                single-line
                hide-details/>
            </v-flex>
            <v-flex
              xs6
              sm6
              md3
            >
              <v-select
                v-model="searchBy.status"
                :items="['','OPEN','WIN','LOSE']"
                menu-props="auto"
                label="Status"
                input-value="-ALL-"
                placeholder="Select..."
              >
                <template v-slot:label>
                  Status <v-icon style="vertical-align: middle">search</v-icon>
                </template>
              </v-select>
            </v-flex>
            <v-flex
              xs6
              sm6
              md3
            >
              <v-select
                v-model="searchBy.createdBy"
                :items="userLogins"
                :item-text="usernameItemText"
                item-value="username"
                menu-props="auto"
                input-value="-ALL-"
                placeholder="Select..."
              >
                <template v-slot:label>
                  Created By <v-icon style="vertical-align: middle">search</v-icon>
                </template>
              </v-select>
            </v-flex>
            <v-flex
              xs6
              sm6
              md3
            >
              <v-text-field
                v-model="searchBy.amount"
                prepend-icon="mdi-calculator"
                type="number"
                hide-details>
                <template v-slot:label>
                  Amount <v-icon style="vertical-align: middle">search</v-icon>
                </template>
              </v-text-field>
            </v-flex>
          </v-layout>

          <v-dialog
            v-model="dialog"
            persistent
            max-width="720px">
            <template v-slot:activator="{ on }">
              <v-btn
                color="general"
                class="mb-2 ml-1 mr-1"
                dark
                v-on="on">New
              </v-btn>
            </template>
            <v-form
              id="form1-vue"
              ref="form1"
              v-model="valid1"
              :lazy-validation="lazyValidation1"
            >
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex
                          xs12
                          sm6
                          md6
                      >
                        <v-text-field
                            v-model="editedItem.name"
                            :rules="[rules.required]"
                            label="Shodan Name *"
                            required
                            persistent-hint
                            hint="Auto create prefix SHO/[year]/[month]/[digit]- after save"
                            class="blue-input"/>
                      </v-flex>
                      <v-flex
                          xs12
                          sm6
                          md4
                      >
                        <v-text-field
                            v-model="editedItem.amount"
                            :rules="[rules.number,rules.required]"
                            label="Amount *"
                            required
                            class="blue-input"/>
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-autocomplete
                          v-model="editedItem.customer.company"
                          :items="companies"
                          :rules="[rules.required]"
                          :search-input.sync="searchCompany"
                          hide-no-data
                          placeholder="type 3 words to search..."
                          label="Company *"
                          item-text="name"
                          item-value="id"
                          return-object
                          required
                          @input="getCustomers"
                        />
                      </v-flex>
                      <v-flex
                          xs12
                          sm6
                          md6
                      >
                        <v-select
                          v-show="showCustomerSelect"
                          :items="customers"
                          v-model="editedItem.customerSelect"
                          :rules="[rules.required]"
                          menu-props="auto"
                          item-text="name"
                          item-value="id"
                          label="Customer *"
                          return-object
                          placeholder="Select Customer..."
                        />
                      </v-flex>

                      <v-flex
                          xs12
                          sm6
                          md6
                      >
                        <v-select
                            v-model="editedItem.status"
                            :items="shodanStatus"
                            :rules="[rules.required]"
                            menu-props="auto"
                            label="Status *"
                            required
                            class="blue-input"/>
                      </v-flex>
                      <v-flex
                          xs12
                          sm6
                          md6
                      >
                        <v-textarea
                          v-model="editedItem.desc"
                          :rules="[rules.required]"
                          label="Desc *"
                          counter
                          required
                          clearable
                          class="blue-input"
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="red darken-1"
                    flat
                    @click="close">Cancel
                  </v-btn>
                  <v-btn
                    :disabled="!valid1"
                    color="green darken-1"
                    flat
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-btn
            color="general"
            dark
            class="mb-2 ml-1 mr-1"
            @click="$refs.downloadExcel.generate()"
          >
            <download-excel
              ref="downloadExcel"
              :fetch="fetchData"
              :fields="excelFields"
              :before-generate="showProgressBar"
              :before-finish="hideProgressBar"
              class="btn btn-default"
              worksheet="worksheet"
              name="Shodan-All.xls">
              <v-icon>mdi-file-excel</v-icon>&nbsp;
            </download-excel>Export All
          </v-btn>
          <v-progress-linear
            v-show="loadingBar"
            :indeterminate="true"/>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="DataList"
            :pagination.sync="pagination"
            :rows-per-page-items="rowsAmount"
            :total-items="totalRows"
            dense
            expand
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr
                class="expandable"
                @click.stop=" (props.expanded = !props.expanded)">
                <td class="justify-center">
                    <v-icon
                    medium
                    class="mr-2"
                    @click.stop="editItem(props.item)">edit
                  </v-icon>
                  <v-icon
                    medium
                    @click.stop="dialogDeleteShow(props.item)">delete
                  </v-icon>
                </td>
                <td>{{ props.item.customer.company.name }}</td>
                <td>{{ props.item.customer.name }}</td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.desc }}</td>
                <td>{{ props.item.status }}</td>
                <td class="price-format">{{ toPriceFormat(props.item.amount) }}</td>
                <td>{{ toStringDate(props.item.lastUpdateDate) }}</td>
                <td>{{ userLoginMap[props.item.lastUpdateBy] }}</td>
                <td>{{ userLoginMap[props.item.createdBy] }}</td>
                <td>{{ toStringDate(props.item.createdDate) }}</td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-flex mx-3>
                <v-data-table
                    id="shodanvisitlist"
                    :headers="headerVisit"
                    :items="props.item.visitDetail || []"
                    hide-actions
                    dense
                >
                  <template v-slot:items="props">
                    <tr>
                      <td>{{ props.item.visitDate }}</td>
                      <td v-if="hasAttachUrl(props.item)">
                        <a
                            :href="props.item.attachUrl"
                            target="_blank">
                          {{ userLoginMap[props.item.username] }}</a></td>
                      <td v-else>{{ userLoginMap[props.item.username] }}</td>
                      <td class=""> {{ toTimeFormat(props.item.timeStart) }} - {{ toTimeFormat(props.item.timeEnd) }}</td>
                      <td class="">{{ props.item.activity }}</td>
                    </tr>
                  </template>
                </v-data-table>
<!--                <v-data-iterator-->
<!--                  :items="props.item.visitDetail || []"-->
<!--                  content-tag="v-layout"-->
<!--                  hide-actions-->
<!--                  row-->
<!--                  wrap-->
<!--                >-->

<!--                  <template v-slot:item="props">-->
<!--                    <v-flex-->
<!--                      xs3-->
<!--                      sm3-->
<!--                      md2-->
<!--                    >-->
<!--                      <v-card>-->
<!--                        <v-list dense>-->
<!--                          <v-list-tile>-->
<!--                            <v-list-tile-content>Visit On:</v-list-tile-content>-->
<!--                            <v-list-tile-content class="align-end">{{ props.item.visitDate }}</v-list-tile-content>-->
<!--                          </v-list-tile>-->
<!--                          <v-list-tile>-->
<!--                            <v-list-tile-content>Visit By:</v-list-tile-content>-->
<!--                            <v-list-tile-content class="align-end">{{ props.item.username }}</v-list-tile-content>-->
<!--                          </v-list-tile>-->
<!--                          <v-list-tile>-->
<!--                            <v-list-tile-content>Time Start-End:</v-list-tile-content>-->
<!--                            <v-list-tile-content class="align-end">-->
<!--                              {{ toTimeFormat(props.item.timeStart) }} - {{ toTimeFormat(props.item.timeEnd) }}-->
<!--                            </v-list-tile-content>-->
<!--                          </v-list-tile>-->
<!--                          <v-list-tile>-->
<!--                            <v-list-tile-content>Activity:-->
<!--                             {{ props.item.activity }}-->
<!--                            </v-list-tile-content>-->
<!--                          </v-list-tile>-->
<!--                        </v-list>-->
<!--                      </v-card>-->
<!--                    </v-flex>-->
<!--                  </template>-->

<!--                </v-data-iterator>-->
              </v-flex>
            </template>
          </v-data-table>

          <v-dialog
            v-model="dialogDelete"
            max-width="400px">
            <v-card>
              <v-card-title class="headline">System Message Confirmation</v-card-title>
              <v-card-text>
                Are you sure want to remove this record? <br>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>

                <v-btn
                  color="red darken-1"
                  text
                  flat
                  @click="dialogDelete = false"
                >
                  Cancel
                </v-btn>

                <v-btn
                  color="green darken-1"
                  text
                  flat
                  @click="deleteItem(deleteItemRecord)"
                >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </material-card>
      </v-flex>
      <v-snackbar
        v-model="snack"
        :timeout="5000"
        :color="snackColor">
        {{ snackText }}
        <v-icon
          size="16"
          @click="snack = false"
        >
          mdi-close-circle
        </v-icon>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
  import displayFormatterMixins from './../../mixins/displayFormatterMixins'
  import { mapState } from 'vuex'
  export default {
    name: 'Shodan',
    mixins: [displayFormatterMixins],
    data: () => ({
      visitDetail: [],
      shodanStatus: ['OPEN', 'WIN', 'LOSE'],
      mixins: [displayFormatterMixins],
      snack: false,
      snackText: '',
      snackColor: '',
      loadingBar: false,
      valid1: false,
      lazyValidation1: false,
      showCustomerSelect: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        desc: '',
        status: '',
        amount: '',
        customer: {
          id: null,
          name: '',
          company: {
            id: null,
            name: ''
          }
        },
        customerSelect: ''
      },
      defaultItem: {
        id: null,
        name: '',
        desc: '',
        status: 'OPEN',
        amount: '',
        customer: {
          id: null,
          name: '',
          company: {
            id: null,
            name: ''
          }
        },
        customerSelect: ''
      },
      rules: {
        required: value => !!value || 'Required',
        number: value => !isNaN(value) || 'Must be numeric',
        time: value => {
          // ignore `:` masked already
          const pattern = /^([0-1]?[0-9]|2[0-4])([0-5][0-9])(:[0-5][0-9])?$/
          return !value || pattern.test(value) || 'Invalid 24h time format'
        },
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        }
      },
      companies: [],
      customers: [],
      userLogins: [],
      userLoginMap: Map,
      pagination: {sortBy: 'lastUpdateDate', descending: true},
      DataList: [],
      totalRows: 0,
      rowsAmount: [5, 20, 50, 100],
      dialog: false,
      dialogDelete: false,
      deleteItemRecord: {},
      loading: true,
      search: '',
      searchBy: {
        status: 'OPEN',
        createdBy: '',
        amount: ''
      },
      headers: [
        { text: '--Actions--', value: 'actions', sortable: false },
        { text: 'Company', value: 'customer.company.id' },
        { text: 'Customer', value: 'customer.customer.id' },
        { text: 'Name', value: 'name' },
        { text: 'Desc', value: 'desc' },
        { text: 'Status', value: 'status' },
        { text: 'Amount', value: 'amount', align: 'right' },
        { text: 'Update Date Time', value: 'lastUpdateDate' },
        { text: 'Update By', value: 'lastUpdateBy' },
        { text: 'Create By', value: 'createdBy' },
        { text: 'Create Date', value: 'createdDate' },
      ],
      headerVisit: [
        { text: 'Visit On', value: 'visitDate' },
        { text: 'Visit By', value: 'username' },
        { text: 'Time Start-End', value: 'timeStart', sortable: false },
        { text: 'Activity', value: 'timeStart' },
      ],
      excelFields: {
        'Company': 'customer.company.name',
        'Customer': 'customer.name',
        'Name': 'name',
        'Desc': 'desc',
        'Status': 'status',
        'Amount': 'amount',
        'Update Date Time': {
          callback: (value) => {
            return new Date(value.lastUpdateDate).toLocaleDateString('en-GB')
          }
        },
        'Update By': 'lastUpdateBy',
        'Create By': 'createdBy'
      },
      searchCompany: ''
    }),

    computed: {
      ...mapState(['user'])
    },
    watch: {
      searchBy: {
        async handler () {
          this.debouncedGetData()
        },
        deep: true
      },
      pagination: {
        async handler () {
          this.getShodan()
        }
      },
      search () {
        this.debouncedGetData()
      },
      searchCompany () {
        if (this.searchCompany && this.searchCompany.length >= 3) {
          this.debouncedGetCompanies()
        }
      }
    },
    created () {
      // this.getCompanies()
      this.getUserLoginsMap()
      this.debouncedGetCompanies = _.debounce(this.getCompaniesPaging, 500)
      this.debouncedGetData = _.debounce(this.getShodan, 500)
      this.getUserLogins()
    },
    methods: {
      hasAttachUrl (item) {
        return !_.isEmpty(item.attachUrl)
      },
      async getUserLoginsMap () {
        try {
          let response = await this.$http.get(`/api/userlogin/all`)
          let userLogins = response.data
          this.userLoginMap = userLogins.reduce(function(map, obj) {
            map[obj.username] = obj.employee.firstName
            return map
          }, {})
        } catch (error) {
          console.log(error)
        }
      },
      usernameItemText (item) {
        if (item.employee) { // bug workaround
          return item.username + ' (' + item.employee.firstName + ')'
        } else {
          return item.username
        }
      },
      async fetchData () {
        const response = await this.$http.get(`/api/shodan/all`)
        return response.data
      },
      showProgressBar () {
        this.loadingBar = true
      },
      hideProgressBar () {
        this.loadingBar = false
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      async getShodan () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search || ''
          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/shodan?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || 'lastUpdateDate'}&dc=${descending || false}&q=${q}&qst=${this.searchBy.status}&qcb=${this.searchBy.createdBy}&qam=${this.searchBy.amount}`)

          this.loading = false
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },
      async getUserLogins () {
        try {
          let response = await this.$http.get(`/api/userlogin/select`)
          this.userLogins = response.data
          this.userLogins.unshift({ id: null, username: '' })
        } catch (error) {
          console.log(error)
        }
      },
      async getCustomers () {
        try {
          let response = await this.$http.get(`/api/customer/select?companyId=${this.editedItem.customer.company.id}`)
          this.customers = response.data
          let custobj = _.find(this.customers, ['id', this.editedItem.customer.id])
          this.editedItem.customerSelect = custobj || ''
          this.showCustomerSelect = true
        } catch (error) {
          console.log(error)
        }
      },
      async getCompaniesPaging () { // paging not yet implemented
        try {
          // const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.searchCompany == null ? '' : this.searchCompany
          // let pageNoXHR = page - 1
          // let response = await this.$http.get(`/api/company/select?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)
          let response = await this.$http.get(`api/company/autocomplete?ps=100&pn=0&so=name&q=${q}`)

          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getCompanies () {
        try {
          let response = await this.$http.get('/api/company/select')
          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },

      reset () {
        this.$refs.form1.resetValidation()
        this.resetInline()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.showCustomerSelect = false
      },
      close () {
        this.dialog = false
        this.$refs.form1.resetValidation()
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      async editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.searchCompany = this.editedItem.customer.company.name
        this.getCompaniesPaging()
        this.getCustomers()
        this.dialog = dbox
      },
      async deleteItem (rec) {
        this.dialogDelete = false
        let endpoint = `api/shodan/${rec.id}`
        let method = 'delete'
        let s = {}
        try {
          let response = await this.$store.dispatch('updateTableItem', { endpoint, s, method })
          if (response.data.message == 'FAILED') {
            this.cancelInline(response.data.details)
            return
          }
          this.DataList.splice(this.DataList.indexOf(rec), 1)
          this.deleteInline()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
      },
      async save () {
        if (!this.$refs.form1.validate()) {
          console.log('validation fail direct')
          return false
        }
        let tableItem = this.editedItem
        tableItem.customer = this.editedItem.customerSelect
        if (this.editedIndex > -1) {
          let endpoint = `api/shodan/${this.editedItem.id}`
          let method = 'patch'
          try {
            let response = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            if (response.data.message == 'FAILED') {
              this.cancelInline(response.data.details)
              return
            }
            Object.assign(this.DataList[this.editedIndex], this.editedItem)
            this.saveInline()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        } else {
          let endpoint = `api/shodan`
          let method = 'post'
          try {
            let resp = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            this.saveInline()
            this.getShodan()
          } catch (error) {
            console.log(error)
            this.cancelInline()
          }
        }
        this.close()
      },
      showQuoRef (obj) {
        if (!_.isEmpty(obj.quotation) && !_.isEmpty(obj.quotation.id)) {
          return obj.quotation.refNo
        } else {
          return 'N'
        }
      },
      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (text) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = text || 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      resetInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      }
    }

  }
</script>
<style>
  #shodanvisitlist thead tr {
    background-color: antiquewhite;
  }

  #shodanvisitlist table.v-table thead tr th {
    font-size: 1.025em;
  }
</style>
